export const integrateMenuDeprecatedRouteMap = {
  "/customers/:customerId/assets": "/customers/:customerId/integrate/assets",
  "/customers/:customerId/assets/:tab/:assetId": "/customers/:customerId/integrate/assets/:tab/:assetId",
  "/customers/:customerId/assets/:tab?/:assetId?/:transfer?":
    "/customers/:customerId/integrate/assets/:tab?/:assetId?/:transfer?",

  "/customers/:customerId/assets/g-suite/create": "/customers/:customerId/integrate/assets/g-suite/create",
  "/customers/:customerId/assets/office-365/create": "/customers/:customerId/integrate/assets/office-365/create",

  "/customers/:customerId/assets/kubernetes/:clusterId/agent/install":
    "/customers/:customerId/integrate/assets/kubernetes/:clusterId/agent/install",
  "/customers/:customerId/assets/kubernetes/:clusterId/agent/upgrade":
    "/customers/:customerId/integrate/assets/kubernetes/:clusterId/agent/upgrade",

  "/customers/:customerId/assets/kubernetes/activate/eks":
    "/customers/:customerId/integrate/assets/kubernetes/activate/eks",
  "/customers/:customerId/assets/kubernetes/activate/gke":
    "/customers/:customerId/integrate/assets/kubernetes/activate/gke",

  "/customers/:customerId/assets/kubernetes/activate/bulk":
    "/customers/:customerId/integrate/assets/kubernetes/activate/bulk",
  "/customers/:customerId/assets/kubernetes/activate/eks/cloud-diagrams":
    "/customers/:customerId/integrate/assets/kubernetes/activate/eks/cloud-diagrams",

  "/customers/:customerId/settings/gcp": "/customers/:customerId/integrate/gcp",

  "/customers/:customerId/settings/gcp/connect/:type(organization|project|dataset)":
    "/customers/:customerId/integrate/gcp/connect/:type(organization|project|dataset)",
  "/customers/:customerId/settings/gcp/connect/:type(organization|project|dataset)/:id":
    "/customers/:customerId/integrate/gcp/connect/:type(organization|project|dataset)/:id",

  "/customers/:customerId/settings/azure": "/customers/:customerId/integrate/azure",
  "/customers/:customerId/settings/azure/connect": "/customers/:customerId/integrate/azure/connect",

  "/customers/:customerId/settings/aws": "/customers/:customerId/integrate/aws",
  "/customers/:customerId/settings/aws/link": "/customers/:customerId/integrate/aws/link",
  "/customers/:customerId/settings/aws/:accountId": "/customers/:customerId/integrate/aws/:accountId",

  "/customers/:customerId/datasets": "/customers/:customerId/integrate/datahub",
  "/customers/:customerId/datasets/:datasetName?": "/customers/:customerId/integrate/datahub/:datasetName?",

  "/customers/:customerId/integrations/zapier": "/customers/:customerId/integrate/app-integrations/zapier",
  "/customers/:customerId/integrations/slack": "/customers/:customerId/integrate/app-integrations/slack",
  "/customers/:customerId/integrations/jira": "/customers/:customerId/integrate/app-integrations/jira",
  "/customers/:customerId/integrations/msteams": "/customers/:customerId/integrate/app-integrations/msteams",
};
